<template>
	<div>
		<Header :active="1"></Header>
		<div class="searchDiv">
			<div class="content">
				<div class="position">
					当前位置：
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/' }">网站首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/jobHunting' }">找工作</el-breadcrumb-item>
						<el-breadcrumb-item>职位详情</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
		</div>
		<div v-loading="loading" class="details-div">
			<div v-if="detailInfo.companyDto" class="content">
				<div class="header flex">
					<div class="left">
						<el-carousel trigger="click" height="282px">
							<el-carousel-item v-for="(item,index) in detailInfo.companyDto.workEnviron" :key="index">
								<img :src="handelHttps(item)" >
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="right">
						<div class="title">
							{{detailInfo.jobDto.employName}}
							<img v-if="detailInfo.jobDto.employProcess == 'PUBLISHED' && detailInfo.jobDto.hotspot == 'START'" src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P6.png">
						</div>
						<div class="money">
							{{detailInfo.jobDto.startSalary|handlePay(detailInfo.jobDto.endSalary)}}/月
						</div>
						<div class="welfare">
							<div v-for="(i,index) in detailInfo.jobDto.welfare" :key="index">{{i}}</div>
						</div>
						<div class="treatment">
							学历要求：
							<template v-for="(i,indexs) in educationList">
								<span :key="indexs" class="line" v-if="detailInfo.requireDto.education === i.value">{{i.text}}</span>
							</template>
							<span style="padding: 0 10px;"></span>
							工作年限：
							<template v-for="(i,indexs) in workingYearList">
								<span :key="indexs" class="line" v-if="detailInfo.requireDto.workingYears === i.value">{{i.text}}</span>
							</template>
							<!-- 年龄要求：18~45周岁 -->
						</div>
						<div class="treatment">
							工作地点：[{{detailInfo.companyDto.address. province}}-{{detailInfo.companyDto.address. city}}-{{detailInfo.companyDto.address. county}}]
						</div>
						<div class="treatment">
							详细地址：{{detailInfo.jobDto.workAddress.addressDetail||'暂无'}}
						</div>
						<div class="reward flex">
							<div class="reward-list flex">
								<div v-if="detailInfo.jobDto.commission!=0&&(detailInfo.hiredCustomerId!==detailInfo.jobDto.customerId||detailInfo.jobDto.interior==0)" class="reward-one">
									推荐奖励￥{{detailInfo.jobDto.commission / 100| keepOne}}
								</div>
								<div v-if="detailInfo.jobDto.refund!=0" class="reward-two">
									入职补贴￥{{detailInfo.jobDto.refund / 100| keepOne}}
								</div>
								<div v-if="detailInfo.jobDto.bounty!=0" class="reward-three">
									赏金￥{{detailInfo.jobDto.bounty / 100| keepOne}}
								</div>
							</div>
							<div @click="interview()" class="reward-anniu">
								申请面试
							</div>
						</div>
					</div>
				</div>
				<div class="introduce">
					<div class="left">
						<div class="list-div">
							<div class="title">
								工资福利
							</div>
							<div class="why">
								我能拿多少工资
							</div>
							<table>
								<tr>
									<td style="width: 229px;">薪资数额</td>
									<td>{{detailInfo.jobDto.startSalary|handlePay(detailInfo.jobDto.endSalary)}}元/月</td>
								</tr>
								<tr>
									<td>结算方式</td>
									<td>{{detailInfo.jobDto.salaryType == 'MONTH' ? '月结' : '其他'}}</td>
								</tr>
								<tr>
									<td>薪资说明</td>
									<td style="padding: 30px;height: 49px;" v-html="detailInfo.attributeDto.salaryDesc"></td>
								</tr>
								<tr>
									<td>其他福利</td>
									<td><span style="padding-right: 15px;" v-for="(i,index) in detailInfo.jobDto.welfare" :key="index">{{i}}</span></td>
								</tr>
							</table>
						</div>
						<div class="list-div">
							<div class="title">
								职位描述
							</div>
							<div class="why">
								我需要做什么
							</div>
							<table>
								<tr>
									<td style="text-align: left;" v-html="detailInfo.attributeDto.jobDesc"></td>
								</tr>
							</table>
						</div>
						<div class="list-div">
							<div class="why">
								录用条件
							</div>
							<table>
								<tr>
									<td style="width: 229px;">学历要求</td>
									<td>
										<template v-for="(i,indexs) in educationList">
											<span :key="indexs" class="line" v-if="detailInfo.requireDto.education === i.value">{{i.text}}</span>
										</template>
									</td>
								</tr>
								<tr>
									<td>工作年限</td>
									<td>
										<template v-for="(i,indexs) in workingYearList">
											<span :key="indexs" class="line" v-if="detailInfo.requireDto.workingYears === i.value">{{i.text}}</span>
										</template>
									</td>
								</tr>
								<tr>
									<td>年龄要求</td>
									<td>{{detailInfo.requireDto.age}}岁</td>
								</tr>
								<tr>
									<td>性别要求</td>
									<td>
										<template v-for="(i,indexs) in sexList">
											<span :key="indexs" class="line" v-if="detailInfo.requireDto.sex === i.value">{{i.label}}</span>
										</template>
									</td>
								</tr>
							</table>
						</div>
						<div class="list-div">
							<div class="why">
								特别说明
							</div>
							<table>
								<tr>
									<td style="text-align: left;">{{detailInfo.attributeDto.specialDesc||'无'}}</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="right">
						<div class="title">
							企业介绍
						</div>
						<div class="enterprise">
							<div class="name">
								{{detailInfo.companyDto.company}}
							</div>
							<div class="jieshao">
								<img class="logo" :src="handelHttps(detailInfo.companyDto.companyLogo)">
								<div class="situation">
									<div class="text">
										企业规模：{{detailInfo.companyDto.scale}}
									</div>
									<div class="text">
										所属行业：{{detailInfo.companyDto.industry}}
									</div>
									<div class="paizi">
										<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/xy.png">
										<div>{{detailInfo.jobDto.creditScore}} 分 {{this.getScoreText(detailInfo.jobDto.creditScore)}}</div>
									</div>
								</div>
							</div>
							<div :class="{'showTwoRow':!fullTextOn}" class="enterprise-text" v-html="detailInfo.companyDto.abbreviation"></div>
							<div @click="fullTextOn=!fullTextOn" class="fullText">
								{{fullTextOn?'收起':'查看全文'}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="申请面试" :visible.sync="centerDialogVisible" width="560px" center>
			<div v-if="detailInfo.jobDto" class="reweima">
				<div class="left">
					<div class="title">
						{{detailInfo.jobDto.employName}}
					</div>
					<div class="money">
						{{detailInfo.jobDto.startSalary|handlePay(detailInfo.jobDto.endSalary)}}/月
					</div>
					<div class="welfare">
						<div v-for="(i,indext) in detailInfo.jobDto.welfare" :key="indext">{{i}}</div>
					</div>
					<div class="Company">
						{{detailInfo.companyDto.company}}
					</div>
					<div class="address">
						<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/adress.png" >
						{{detailInfo.companyDto.address. addressDetail||'暂无'}}
					</div>
				</div>
				<div v-loading="qrCodeLoading" class="right">
					<img :src="qrCode" alt="小程序二维码">
					<div>手机微信扫一扫  申请面试</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Header from '../components/subHead.vue'
	export default {
		name: "JobDetails",
		components: {
			Header
		},
		data() {
			return {
				fullTextOn: false,
				centerDialogVisible: false,
				detailInfo:{},
				workingYearList:[],
				educationList:[],
				sexList:[],
				qrCode:'',
				inviteCode:'',
				loading:false,
				qrCodeLoading:false
			}
		},
		async mounted() {
			this.educationList = await this.getTable('INTERVIEWEDUCATIONTYPEENUM');
			this.workingYearList = await this.getTable('INTERVIEWWORKPERIODENUM');
			this.sexList = await this.getTable('SEXENUM');
			this.inviteCode = await this.getInviteCode()
			this.detailById();
		},
		methods: {
			/**
			 * 获取二维码
			 */
			makeQrcode(){
				this.qrCodeLoading = true;
				let params = {
					scene: this.$route.query.id+'&'+this.inviteCode+'&OFFICIAL_WEBSITE',
					page: "packageHome/pages/home/job/detail"
				}
				this.http.get('/wx/ma/qrcode',params).then(res => {
					console.log(res.data);
					this.qrCode = 'data:image/png;base64,' + res.data;
					setTimeout(()=>{this.qrCodeLoading = false;},500)
				}).catch(err => console.log(err))
			},
			getInviteCode() {
				let params = {codeEnum: 'REGISTER_USER'}
				return new Promise((resolve) => {
					this.http.get('/officialWebsite/getOfficialWebsiteInviteCode', params).then(res => {
						resolve(res.data.data)
					})
				})
			},
			/**
			 * 根据id获取详情
			 */
			detailById(){
				this.loading = true;
				let params = {id: this.$route.query.id}
				this.http.get('/officialWebsite/recruitment/detailById',params).then(res => {
					console.log(res.data.data);
					this.detailInfo=res.data.data;
					setTimeout(()=>{this.loading = false;},500)
				}).catch(err => console.log(err))
			},
			/**
			 * 获取筛选列表
			 */
			getTable(type) {
				let params = {
					tableDataEnum: type
				}
				return new Promise((resolve) => {
					this.http.get('/getTableDataByParam', params).then(res => {
						resolve(res.data.data)
					})
				})
			},
			interview() {
				this.centerDialogVisible = true;
				this.makeQrcode();
			},
			getScoreText(num) {
				if (0 <= num && num <= 40) {
					return "较差";
				} else if (40 < num && num <= 60) {
					return "一般";
				} else if (60 < num && num <= 80) {
					return "良好";
				} else if (80 < num && num <= 100) {
					return "优秀";
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.reweima{
		.right{
			img{
				width: 180px;
				height: 180px;
				margin-bottom: 19px;
			}
			text-align: center;
			font-size: 14px;
			color: #666;
			margin-left: 28px;
		}
		.left{
			.address{
				font-size: 14px;
				color: #666666;
				img{
					width: 10px;
					height: 12px;
					margin-right: 3px;
				}
				display: flex;
				align-items: center;
				margin-top: 3px;
			}
			.Company{
				margin-top: 22px;
				font-size: 16px;
				color: #333;
			}
			.welfare {
				display: flex;
				flex-wrap: wrap;
				margin-bottom: 20px;
				border-bottom: 1px dashed #DDDDDD;
				padding-bottom: 25px;
				div {
					padding: 4px 12px;
					background-color: #E5FCFF;
					color: #00BCD4;
					font-size: 14px;
					border-radius: 4px;
					margin: 0 12px 12px 0;
				}
			}
			
			.money {
				font-size: 24px;
				color: #FF4A32;
				margin-bottom: 20px;
			}
			
			.title {
				color: #333333;
				font-size: 20px;
				display: flex;
				align-items: center;
				margin-bottom: 15px;
			}
			width: 292px;
			margin-top: 17px;
		}
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}
	/deep/.el-dialog{
		border-radius: 6px!important;
	}
	/deep/.el-dialog__header{
		border-bottom: 1px solid #DDDDDD;
	}
	.details-div {
		.introduce {
			.right {
				.enterprise {
					.showTwoRow {
						text-align: left;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 5;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}

					.fullText {
						color: #00BCD4;
						font-size: 14px;
						text-align: right;
						margin-top: 15px;
						cursor: pointer;
					}

					.enterprise-text {
						font-size: 14px;
						color: #666666;
					}

					.jieshao {
						.situation {
							.paizi {
								div {
									font-size: 12px;
									color: #BE8729;
									position: absolute;
									top: 7px;
									left: 30px;
								}

								width: 96px;
								height: 31px;
								position: relative;
							}

							.text {
								font-size: 14px;
								color: #666666;
								margin-bottom: 9px;
							}
						}

						.logo {
							width: 80px;
							height: 80px;
							border-radius: 6px;
							border: 1px solid #DDDDDD;
							margin-right: 12px;
						}

						margin-bottom: 19px;
						display: flex;
					}

					.name {
						font-size: 16px;
						color: #333333;
						margin-bottom: 20px;
					}

					margin-top: 19px;
					padding: 20px;
					background-color: #FBFBFB;

				}

				.title {
					font-size: 18px;
					color: #333333;
				}
			}

			.left {
				.list-div {
					margin-bottom: 30px;
				}

				td {
					height: 79px;
					text-align: center;
					font-size: 14px;
					color: #666666;
					padding: 0 30px;
				}

				tr:nth-of-type(even) {
					background-color: #FBFBFB;
				}

				table,
				td {
					border: 1px solid #DDDDDD;
				}

				table {
					width: 100%;
					border-collapse: collapse;
				}

				.why {
					font-size: 14px;
					color: #00BCD4;
					padding-left: 9px;
					border-left: 3px solid #00BCD4;
					margin: 18px 0;
				}

				.title {
					font-size: 18px;
					color: #333333;
				}

				width: 860px;
			}

			.right {
				width: 300px;
			}

			display: flex;
			justify-content: space-between;
			margin-top: 58px;
		}

		.header {
			.right {
				.reward {
					.reward-anniu:hover{
						background-color: #00bcd48a;
					}
					.reward-anniu {
						width: 160px;
						height: 60px;
						text-align: center;
						line-height: 60px;
						font-size: 18px;
						color: #FFFFFF;
						border-radius: 4px;
						background-color: #00BCD4;
						cursor: pointer;
					}

					.reward-list {
						.reward-three {
							border: 1px solid #089DFE;
							color: #089DFE;
						}

						.reward-two {
							border: 1px solid #FB7E1E;
							color: #FB7E1E;
						}

						.reward-one {
							border: 1px solid #FD4459;
							color: #FD4459;
						}

						div {
							font-size: 14px;
							padding: 7px 12px;
							border-radius: 4px;
							margin-right: 15px;
						}
					}
				}

				.treatment {
					font-size: 14px;
					color: #666666;
					margin-bottom: 9px;
				}

				.welfare {
					display: flex;
					margin-bottom: 20px;

					div {
						padding: 4px 12px;
						background-color: #E5FCFF;
						color: #00BCD4;
						font-size: 14px;
						border-radius: 4px;
						margin-right: 12px;
					}
				}

				.money {
					font-size: 24px;
					color: #FF4A32;
					margin-bottom: 12px;
				}

				.title {
					color: #333333;
					font-weight: bold;
					font-size: 24px;
					display: flex;
					align-items: center;
					margin-bottom: 15px;

					img {
						width: 23px;
						height: 23px;
						margin-left: 15px;
					}
				}

				width: 670px;
				height: 282px;
				margin-left: 30px;
			}

			// /deep/.el-carousel__indicators--horizontal{
			// 	left: 85%;
			// }
			/deep/.el-carousel__button {
				width: 10px;
				height: 10px;
				border-radius: 50%;
			}

			.left {
				width: 500px;
				height: 282px;
				background-color: #666666;
				img{
					width: 100%;
					height: 100%;
				}
			}
		}

		padding: 30px 0;
	}

	.searchDiv {
		/deep/.el-breadcrumb__item .is-link {
			font-weight: 400!important;
		}
		/deep/.el-breadcrumb__inner:hover{
			color: #00BCD4;
		}
		/deep/.el-breadcrumb__inner{
			color: #999999;
		}
		.position {
			font-size: 14px;
			color: #999999;
			display: flex;
			align-items: center;
		}

		width: 100%;
		background-color: #FBFBFB;
		padding: 30px 0;
	}

	.content {
		width: 1200px;
		margin: auto;
	}
</style>
